// Params that Stripe appends to a confirmSetup/confirmPayment `return_url`, plus
// our own `confirmed` marker. Kept in one place so the funnel's success cleanup
// (short-drama.tsx), the failed-return cleanup (PaywallStep), and the return_url
// builder (PaywallStep) can never drift apart — a stale `redirect_status` left on
// the URL would otherwise make a successful retry read as a failure.
const STRIPE_RETURN_PARAMS = [
  "confirmed",
  "redirect_status",
  "setup_intent",
  "setup_intent_client_secret",
  "payment_intent",
  "payment_intent_client_secret",
] as const;

// Remove all Stripe redirect-return params (and our `confirmed` marker) from `url`,
// mutating and returning it so callers can then set a fresh `step`/`confirmed`.
export function stripStripeReturnParams(url: URL): URL {
  for (const key of STRIPE_RETURN_PARAMS) {
    url.searchParams.delete(key);
  }
  return url;
}
